import React from 'react'
import { Button } from '@enamelai/design-system'

type DownloadPDFButtonProps = {
  handleDownloadPDF: () => void
}

const DownloadPDFButton = ({
  handleDownloadPDF,
}: DownloadPDFButtonProps): React.ReactElement => (
  <Button type="button" variant="primary" onClick={handleDownloadPDF}>
    Download PDF
  </Button>
)

export default DownloadPDFButton
